import { render, staticRenderFns } from "./SingleFilter.vue?vue&type=template&id=2957b9b6"
import script from "./SingleFilter.vue?vue&type=script&lang=js"
export * from "./SingleFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports